import { isNullOrUndefined } from "./storeFunctions";

export function loadMulti(obj, domain, initialLevelLength = 2, valueLevelLength = 2, addParents = false) {
    if (isNullOrUndefined(obj) || isNullOrUndefined(domain.requestResult) || domain.requestResult.length === 0)
        return undefined;

    const result = {};
    if (obj.allSelected) {
        obj.all = [];
        domain.requestResult.forEach(r => findChildren(r, obj.all, addParents));
    }
    var longest = obj.all.length > 0 ? Math.max(...obj.all.map(v => v.length)) : 0;
    var parents = findParents(obj.all, longest);

    const all = obj.all.slice(0).map(i => findInTree(i, domain.requestResult, initialLevelLength, valueLevelLength));
    const parent = parents.map(i => findInTree(i, domain.requestResult, initialLevelLength, valueLevelLength));
    result.all = all.filter(f => !isNullOrUndefined(f) && !isNullOrUndefined(f.value));
    result.parent = parent.filter(f => !isNullOrUndefined(f) && !isNullOrUndefined(f.value));
    result.allSelected = obj.allSelected;
    return result;
}

export function loadMultiCities(obj, domain) {
    if (isNullOrUndefined(obj) || isNullOrUndefined(domain.requestResult) || domain.requestResult.length === 0)
    return undefined;

    const result = {};
    result.all = [];
    result.parent = [];

    domain.requestResult.forEach(district => {
     district.children.map(x => {
       if (obj.all.includes(x.value)) {
            result.all.push(x);
       }
     })   
    });

    let parents = [...new Set(result.all.map(x => x.parentId))];
    result.parent = domain.requestResult.filter(rdc => parents.includes(rdc.value) && rdc.parentId === null)
    result.allSelected = obj.allSelected;
    return result;
}

export function findInTree(value, tree, initialLevelLength, valueLevelLength) {
    if (isNullOrUndefined(value) || value.length < valueLevelLength || isNullOrUndefined(tree)
        || valueLevelLength <= 0 || value.length % valueLevelLength !== 0)
        return null;

    let node = null;
    for (var i = 0; i < value.length; i = i + valueLevelLength) {
        if (i === 0) {
            node = { ...tree.find(f => f.value === value.substring(0, initialLevelLength)) }
            i = i + (initialLevelLength - valueLevelLength);
        }
        else if (!isNullOrUndefined(node) && !isNullOrUndefined(node.children)) {
            var tmpNode = { ...node.children.find(f => f.value === value.substring(0, i + valueLevelLength)) }
            if (isNullOrUndefined(tmpNode.value) && value.endsWith('SK')) {    //nace special case, parent 1 level higher
                i += valueLevelLength;
                node = { ...node.children.find(f => f.value === value.substring(0, i + valueLevelLength)) }
            }
            else
                node = tmpNode;
        }
        else
            break;
    }

    if (!isNullOrUndefined(node) && node.children !== undefined)
        node.children = undefined;

    return node;
}

export function findParents(values, maxLen, valueLevelLength = 2) {
    let parents = [];
    for (var i = valueLevelLength; i <= maxLen; i = i + valueLevelLength) {
        let group = values.filter(f => f.length === i);
        if (i === valueLevelLength)
            parents.push(...group);
        else {
            for (var v in group) {
                var ss = getSubstrings(group[v], valueLevelLength);
                if (ss.filter(f => !parents.includes(f)).length === ss.length)
                    parents.push(group[v]);
            }
        }
    }
    return parents;
}

export function getSubstrings(item, valueLevelLength) {
    let substrings = [];
    let x = item.length - valueLevelLength
    while (x >= valueLevelLength) {
        substrings.push(item.substring(0, x));
        x = x - valueLevelLength;
    }
    return substrings;
}
export function loadRegionDistrictCity(obj, domain) {
    for (let i = 0; i < obj.rdc.length; i++) {
        let fullItem = domain.requestResult.find(x => x.value === obj.rdc[i]);
        obj.rdc[i] = { ...fullItem };
    }
}
export function filterMulti(obj, domain, wrap, addParents = false) {
    var allValues = [];
    
    //Fix null requestResult
    if (!isNullOrUndefined(domain.requestResult)) 
        domain.requestResult.forEach(r => findChildren(r, allValues, addParents));

    obj.allSelected = true;

    if (obj.all.length === allValues.length)
        obj.all.forEach(o => {
            if (allValues.indexOf(o.value) === -1) {
                obj.allSelected = false;
            }
        });
    else
        obj.allSelected = false;

    if (wrap === true) {
        obj.all = obj.all.map(x => { return { 'value': x.value } });
    } else {
        if (obj.allSelected)
            obj.all = null;
        else
            obj.all = obj.all.map(x => x.value);
    }

    delete obj.parent;
}

export function findChildren(node, values, addParents) {
    if (!isNullOrUndefined(node.children) && node.children.length > 0) {
        node.children.forEach(c => findChildren(c, values, addParents));
        if (addParents)
            values.push(node.value);
    }
    else
        values.push(node.value);
}